import React from 'react';
import { Swiper } from 'swiper/react';
import SwiperPresenter from './SwiperPresenter';

export interface SwiperProps extends Swiper {
  PrevBtn?: () => JSX.Element;
  NextBtn?: () => JSX.Element;
}

const SwiperContainer: React.FC<SwiperProps> = (props) => {
  return <SwiperPresenter {...props} />;
};

export default SwiperContainer;
